{
    "LicenceManagementPage_Title": "Gestão de Licenças",
    "LicenceManagementPage_Subtitle": "Gerencie as atribuições de dispositivos e usuários para um escopo de telefonia selecionado.",
    "LicenceManagementPage_Tile_Analytics": "Análise de experiência do cliente",
    "LicenceManagementPage_Tile_Score": "Pontuação CX",
    "LicenceManagementPage_Tile_Record": "Registro CX",
    "LicenceManagementPage_Tile_Transcribe": "CX Transcribe",
    "LicenceManagementPage_Tile_Integration": "Integração da experiência do cliente",
    "LicenceManagementPage_Tile_Licences": "Licenças",
    "LicenceManagementPage_Column_DeviceNumber": "Dispositivo",
    "LicenceManagementPage_Column_Username": "Nome de usuário",
    "LicenceManagementPage_Column_Email": "E-mail",
    "LicenceManagementPage_Column_HasDevice": "Dispositivo",
    "LicenceManagementPage_Column_Agent": "Agente",
    "LicenceManagementPage_Column_WelcomeEmail": "E-mail de boas-vindas",
    "LicenceManagementPage_Column_Licences": "Licenças",
    "LicenceManagementPage_Column_Actions": "Ações",
    "LicenceManagementPage_Type_Device": "Dispositivo",
    "LicenceManagementPage_Type_User": "Usuário",
    "LicenceManagementPage_Popup_TelSys": "Servidor de telefonia",
    "LicenceManagementPage_Popup_Partition": "Partição",
    "LicenceManagementPage_Popup_Device": "Dispositivo",
    "LicenceManagementPage_Popup_Username": "Nome de usuário",
    "LicenceManagementPage_Popup_Email": "E-mail",
    "LicenceManagementPage_Popup_Close": "Fechar",
    "LicenceManagementPage_LicencePopup_Title": "Gerenciar licenças de produtos",
    "LicenceManagementPage_LicencePopup_Licence": "Licença",
    "LicenceManagementPage_LicencePopup_ScoreUserCalls": "Pontuação das chamadas do usuário",
    "LicenceManagementPage_LicencePopup_RecordUserCalls": "Gravar chamadas do usuário",
    "LicenceManagementPage_LicencePopup_IntegrationEnabled": "Habilitado",
    "LicenceManagementPage_LicencePopup_On": "Sobre",
    "LicenceManagementPage_LicencePopup_Off": "Desligado",
    "LicenceManagementPage_LicencePopup_Enabled": "Habilitado",
    "LicenceManagementPage_LicencePopup_Disabled": "Desabilitado",
    "LicenceManagementPage_LicencePopup_EmailRequired": "Adicione um endereço de e-mail antes de salvar as alterações de licença para este dispositivo.",
    "LicenceManagementPage_Email_AddTooltip": "Clique para adicionar o e-mail e criar um usuário.",
    "LicenceManagementPage_EssentialsExtension": "Fundamentos (Extensão)",
    "LicenceManagementPage_Empty": "Nada encontrado aqui",
    "LicenceManagementPage_WelcomeEmail_Title": "Reenviar e-mail de boas-vindas para \"{}\"",
    "LicenceManagementPage_WelcomeEmail_Confirm": "Deseja reenviar o e-mail de boas-vindas para \"{}\"?",
    "LicenceManagementPage_WelcomeEmail_Success": "O e-mail foi enviado com sucesso para \"{}\"",
    "LicenceManagementPage_WelcomeEmail_Fail": "Ocorreu um erro inesperado ao enviar o e-mail. Por favor, tente novamente.",
    "LicenceManagementPage_Licence_SaveFailed": "Não foi possível ler as configurações atuais do usuário, portanto as licenças não foram salvas. Tente novamente.",
    "LicenceManagementPage_Column_LicencesCount": "[{} Licenças]",
    "LicenceManagementPage_Tick_Save": "Salvar alterações da linha",
    "LicenceManagementPage_Tick_InvalidEmail": "Insira um endereço de e-mail válido para criar o usuário.",
    "LicenceManagementPage_Licence_ScoringEnabled": "Pontuação ativada",
    "LicenceManagementPage_Licence_RecordingEnabled": "Gravação ativada",
    "LicenceManagementPage_Licence_TranscribeEnabled": "Transcribe Enabled",
    "LicenceManagementPage_Licence_WithScoring": "{} + Pontuação",
    "LicenceManagementPage_Licence_WithRecording": "{} + Gravação",
    "LicenceManagementPage_Username_NoUserTooltip": "Este será o nome de usuário quando um novo usuário for criado.",
    "NAME": "Página de Gerenciamento de Licenças - Idioma"
}